import { Link, useNavigate } from "react-router-dom";
import { FaTag, FaTruck, FaShoppingCart } from "react-icons/fa";
import useCart from "./useCart";

const ProductCard = ({
  item,
  currencyClass = "text-emerald-600",
  bgClass = "text-emerald-600",
  cartColor = "text-gray-600",
  textColor = "text-black-600",
}) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const firstVariant = item.variants?.[0] || {};
  const firstImage = firstVariant.images?.[0] || "";

  const selectedTitle = firstVariant.title || "-";
  const selectedPrice = firstVariant.flashPrice || 0;
  const selectedDiscount = firstVariant.discount || 0;
  const freeVariantDelivery = firstVariant?.freeVariantDelivery;

  const discountPercent =
    selectedDiscount > 0
      ? Math.ceil(((selectedDiscount - selectedPrice) / selectedDiscount) * 100)
      : 0;

  const toCurrency = (amount) => `${amount.toLocaleString()} TK`;

  return (
    <Link
      to={`/details/${item.catalogue}/${item.item_id}`}
      className={`sm:basis-auto basis-[calc(50%-6px)] shrink-0 snap-start overflow-hidden rounded-md ${bgClass} text-left backdrop-blur sm:w-[190px] lg:w-[210px]`}
    >
      {/* Image */}
      <div className="relative group aspect-product-desktop w-full overflow-hidden">
        <img
          src={`https://backend.nuhababy.com/${firstImage}`}
          alt={selectedTitle}
          className="transition-transform duration-1000 ease-in-out transform w-full group-hover:scale-105 cursor-pointer rounded-t-[8px] object-cover"
        />

        {discountPercent > 0 && (
          <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-full bg-rose-600 px-2 py-1 text-[10px] font-semibold text-white">
            <FaTag />
            {discountPercent}% OFF
          </span>
        )}

        {freeVariantDelivery === 1 && (
          <span className="absolute bottom-1 right-1 inline-flex items-center gap-1 rounded-full bg-emerald-600/95 px-2 py-1 text-[10px] font-medium text-white">
            <FaTruck />
            Free Delivery
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-2">
        {/* <h4
          className={`line-clamp-2 text-xs font-semibold sm:text-sm ${textColor}`}
        >
          {item?.mainTitle}
        </h4> */}
        <div
          className={`${textColor} hover:text-[#222836] hover:opacity-60 font-medium tracking-wide mb-1 text-sm whitespace-nowrap overflow-hidden truncate`}
        >
          {item?.mainTitle}
        </div>
        <div
          className={`${textColor} hover:text-[#222836] hover:opacity-60 tracking-wide mb-1 text-xs whitespace-nowrap overflow-hidden truncate`}
        >
          {selectedTitle}
        </div>

        <div className="flex items-center gap-2">
          <p className={`text-base font-extrabold ${currencyClass}`}>
            {toCurrency(selectedPrice)}
          </p>

          {selectedDiscount > 0 && (
            <p className="text-xs line-through text-slate-400">
              {toCurrency(selectedDiscount)}
            </p>
          )}
        </div>
      </div>

      {/* Buttons */}
      <div className="px-2 flex items-center gap-2 mb-2">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault(); // 👈 IMPORTANT (prevent Link navigation)
            addToCart(item);
            navigate("/orderDetails");
          }}
          className="flex-1 rounded-md bg-blue-600 px-2 py-2 text-xs font-semibold text-white hover:bg-blue-700"
        >
          Order Now
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            addToCart(item);
          }}
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-200 text-slate-700 hover:bg-slate-100"
        >
          <FaShoppingCart className={`${cartColor}`} />
        </button>
      </div>
    </Link>
  );
};

export default ProductCard;
